import { Box, Button } from "@mui/material";

import { Text } from "@profiler/ui";

export const ContactUs = () => {
  return (
    <div style={{ width: 600, padding: "24px 16px" }}>
      <Box mb={3}>
        <Text fontSize={4} mb={4} color="text">
          Contact us
        </Text>

        <Box
          sx={{
            display: "flex",
            justifyContent: "right",
            marginRight: 1,
          }}
        >
          <Button variant="outlined">{"Submit"}</Button>
        </Box>
      </Box>
    </div>
  );
};
